"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridColumn = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var GridColumn = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.el, TagName = _c === void 0 ? 'div' : _c, desktop = _a.desktop, floated = _a.floated, largescreen = _a.largescreen, mobile = _a.mobile, only = _a.only, stretched = _a.stretched, tablet = _a.tablet, textAlign = _a.textAlign, verticalAlign = _a.verticalAlign, widescreen = _a.widescreen, width = _a.width, props = __rest(_a, ["children", "className", "el", "desktop", "floated", "largescreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"]);
    var desktopColspan = utilities_1.columnsToNumeral(desktop);
    var largescreenColspan = utilities_1.columnsToNumeral(largescreen);
    var mobileColspan = utilities_1.columnsToNumeral(mobile);
    var tabletColspan = utilities_1.columnsToNumeral(tablet);
    var widescreenColspan = utilities_1.columnsToNumeral(widescreen);
    var colspan = utilities_1.columnsToNumeral(width);
    var GridColumnClasses = classnames_1.default('GridColumn', className, (_b = {},
        _b["GridColumn--" + floated + "-floated"] = floated,
        _b["GridColumn--" + only + "-only"] = only,
        _b['GridColumn--stretched'] = stretched,
        _b["GridColumn--text-align-" + textAlign] = textAlign,
        _b["GridColumn--vertical-align-" + verticalAlign] = verticalAlign,
        _b["GridColumn--" + desktopColspan + "-wide-desktop"] = desktopColspan,
        _b["GridColumn--" + largescreenColspan + "-wide-largescreen"] = largescreenColspan,
        _b["GridColumn--" + mobileColspan + "-wide-mobile"] = mobileColspan,
        _b["GridColumn--" + tabletColspan + "-wide-tablet"] = tabletColspan,
        _b["GridColumn--" + widescreenColspan + "-wide-widescreen"] = widescreenColspan,
        _b["GridColumn--" + colspan + "-wide"] = colspan,
        _b));
    return (react_1.default.createElement(TagName, __assign({ className: GridColumnClasses }, props), children));
};
exports.GridColumn = GridColumn;
//# sourceMappingURL=GridColumn.js.map